import { API_BASE_URL, itemsOnPage } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { buildDefaultHeaders } from "./helper";
import { SET_CURRENT_PERIOD, SET_PERIODS_COUNT, SET_PERIODS_LIST, SET_PERIODS_LOADING, SET_PERIODS_PAGE, SET_PERIOD_EXCLUSIONS, SET_PERIOD_EXCLUSIONS_LOADING, SET_PERIOD_GROUPS } from "./types";

const extractErrorMessage = async (response, fallback) => {
  try {
    const body = await response.json();
    return body?.error?.message || body?.error || fallback;
  } catch {
    return fallback;
  }
};


export const setPage = (pageNumber) => ({ type: SET_PERIODS_PAGE, payload: pageNumber })

export const getPeriodsList = ({ year, shift }) => async (dispatch, getState) => {

  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_PERIODS_LOADING, payload: true });
    const urlParams = new URLSearchParams({ year_id: year, shift_id: shift }).toString();
    const response = await fetch(`${API_BASE_URL}/period?${urlParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {

      const { cnt: count, periods } = await response.json();
      const pageCount = Math.ceil(count / itemsOnPage)

      dispatch({ type: SET_PERIODS_LIST, payload: periods });
      dispatch({ type: SET_PERIODS_COUNT, payload: { pageCount, count } });

    }
  }
  dispatch({ type: SET_PERIODS_LOADING, payload: false });
};

export const getCurrentPeriod = (periodId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  dispatch({ type: SET_CURRENT_PERIOD, payload: {} });
  if (getState().auth.token) {
    dispatch({ type: SET_PERIODS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/period/${periodId}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_CURRENT_PERIOD, payload });
    }
  }
  dispatch({ type: SET_PERIODS_LOADING, payload: false });
};

export const deletePeriod = (data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_PERIODS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/period/${data.lid}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const { list, pageNumber } = getState().periods
      list.length < 2 && dispatch(setPage(pageNumber - 1))
      await dispatch(getPeriodsList(data.search));
      dispatch({ type: SET_PERIODS_LOADING, payload: false });
      return { ok: true };
    }
    const message = await extractErrorMessage(response, 'Не удалось удалить период')
    dispatch({ type: SET_PERIODS_LOADING, payload: false });
    return { ok: false, message };
  }
  dispatch({ type: SET_PERIODS_LOADING, payload: false });
  return { ok: false, message: 'Не удалось удалить период' };
};

export const updatePeriod = (lid, data, search) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_PERIODS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/period/${lid}`, {
      method: "PUT",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      await dispatch(getPeriodsList({ year: search.year, shift: search.shift }));
      dispatch({ type: SET_PERIODS_LOADING, payload: false });
      return { ok: true };
    }
    const message = await extractErrorMessage(response, 'Не удалось сохранить период')
    dispatch({ type: SET_PERIODS_LOADING, payload: false });
    return { ok: false, message };
  }
  dispatch({ type: SET_PERIODS_LOADING, payload: false });
  return { ok: false, message: 'Не удалось сохранить период' };
};

// data может содержать вложенный массив exclusions - период и его исключения создаются одной транзакцией
export const createPeriod = (data, search) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_PERIODS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/period`, {
      method: "POST",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const created = await response.json().catch(() => null);
      await dispatch(getPeriodsList({ year: search.year, shift: search.shift }));
      dispatch({ type: SET_PERIODS_LOADING, payload: false });
      return { ok: true, data: created };
    }
    const message = await extractErrorMessage(response, 'Не удалось создать период')
    dispatch({ type: SET_PERIODS_LOADING, payload: false });
    return { ok: false, message };
  }
  dispatch({ type: SET_PERIODS_LOADING, payload: false });
  return { ok: false, message: 'Не удалось создать период' };
};

// POST /period/copy: { source_year_id, target_year_id, overwrite }.
// 409 = у приёмника уже есть распорядок, нужно подтверждение перезаписи (requires_confirmation).
// 400 = нельзя (тот же год либо приёмник используется в расписаниях - тогда есть schedules).
export const copyPeriod = ({ source_year_id, target_year_id, overwrite }) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_PERIODS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/period/copy`, {
      method: "POST",
      body: JSON.stringify({ source_year_id, target_year_id, overwrite: !!overwrite }),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      dispatch({ type: SET_PERIODS_LOADING, payload: false });
      return { ok: true };
    }
    let message = 'Не удалось скопировать распорядок'
    let schedules = []
    let requiresConfirmation = response.status === 409
    try {
      const body = await response.json();
      message = body?.error?.message || body?.error || message
      schedules = body?.schedules || []
      requiresConfirmation = requiresConfirmation || !!body?.requires_confirmation
    } catch { }
    dispatch({ type: SET_PERIODS_LOADING, payload: false });
    return { ok: false, message, schedules, requiresConfirmation };
  }
  dispatch({ type: SET_PERIODS_LOADING, payload: false });
  return { ok: false, message: 'Не удалось скопировать распорядок' };
};

// Эндпоинты исключений (period_id и peid - всегда в пути, не в теле).
export const getPeriodExclusions = (lid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_PERIOD_EXCLUSIONS_LOADING, payload: true });
    const response = await fetch(`${API_BASE_URL}/period/${lid}/exclusions`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_PERIOD_EXCLUSIONS, payload: payload?.exclusions || [] });
    }
  }
  dispatch({ type: SET_PERIOD_EXCLUSIONS_LOADING, payload: false });
};

export const createPeriodExclusion = (lid, data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/period/${lid}/exclusions`, {
      method: "POST",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) return { ok: true };
    return { ok: false, message: await extractErrorMessage(response, 'Не удалось сохранить исключение') };
  }
  return { ok: false, message: 'Не удалось сохранить исключение' };
};

export const updatePeriodExclusion = (lid, peid, data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/period/${lid}/exclusions/${peid}`, {
      method: "PUT",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) return { ok: true };
    return { ok: false, message: await extractErrorMessage(response, 'Не удалось сохранить исключение') };
  }
  return { ok: false, message: 'Не удалось сохранить исключение' };
};

export const deletePeriodExclusion = (lid, peid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(`${API_BASE_URL}/period/${lid}/exclusions/${peid}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) return { ok: true };
    return { ok: false, message: await extractErrorMessage(response, 'Не удалось удалить исключение') };
  }
  return { ok: false, message: 'Не удалось удалить исключение' };
};

// Классы за выбранный учебный год для select "Класс" в форме исключения
export const getPeriodGroups = (year) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const urlParams = new URLSearchParams({ year_id: year }).toString();
    const response = await fetch(`${API_BASE_URL}/groups?${urlParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_PERIOD_GROUPS, payload: payload?.groups || [] });
    }
  }
};
